import { render, staticRenderFns } from "./OnusShow.vue?vue&type=template&id=f489d402&scoped=true&"
import script from "./OnusShow.vue?vue&type=script&lang=js&"
export * from "./OnusShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f489d402",
  null
  
)

export default component.exports